import "react-datepicker/dist/react-datepicker.css";
import { useField, useFormikContext } from "formik";
import CalendarIcon from "../../assets/img/icons/calendar.svg";
import CloseIcon from "../../assets/img/icons/close-black.svg";
import ReactDatePicker from "react-datepicker";
import { StyledDatePickerWrapper } from "../../styles/StyledDatePickerWrapper";
import moment from "moment";
import { PropTypes } from "prop-types";

export default function DatePicker({ ...props }) {
	const { setFieldValue } = useFormikContext();
	const [field] = useField(props);

	return (
		<StyledDatePickerWrapper>
			<ReactDatePicker
				selected={(field.value && new Date(field.value)) || null}
				placeholderText={props.placeholderText ?? "Choose"}
				dateFormat={!props.showTimeSelect ? "yyyy-MM-dd" : "yyyy-MM-dd h:mm"}
				{...field}
				{...props}
				onChange={
					props.handleChange
						? props.handleChange
						: (val) => {
							setFieldValue(
								field.name,
								!props.showTimeSelect ? moment(val).format("YYYY-MM-DD") : moment(val).format("YYYY-MM-DD HH:mm")
							);
						  }
				}
			/>

			{field.value ? (
				<i onClick={props.handleChange ? () => props.handleChange(undefined) : () => setFieldValue(field.name, undefined)}>
					<img src={CloseIcon} alt="delete" />
				</i>
			) : (
				<i>
					<img src={CalendarIcon} alt="date" />
				</i>
			)}
		</StyledDatePickerWrapper>
	);
}

DatePicker.propTypes = {
	showTimeSelect: PropTypes.any,
	placeholderText: PropTypes.string,
	handleChange: PropTypes.func,
};
